import * as React from 'react';

export default (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '24'}
    height={props.height || '24'}
    fill="none"
  >
    <path
      fill="#B5BFD2"
      d="M18.102 5.005A1 1 0 0 1 19 6v3a1 1 0 0 1-.28.692l-.08.077-5.64 4.7V18a1 1 0 1 1-2 0v-3.531l-5.64-4.7A1 1 0 0 1 5 9V6l.005-.103A1 1 0 0 1 6 5h12l.102.005ZM7 8.53l5 4.167 5-4.167V7H7v1.53Z"
    />
  </svg>
);
